import { render } from "./MoreIcons.vue?vue&type=template&id=3130110a"
import script from "./MoreIcons.vue?vue&type=script&lang=ts"
export * from "./MoreIcons.vue?vue&type=script&lang=ts"
script.render = render

export default script